import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ChevronDown } from "lucide-react";
import { Phone, Mail } from "lucide-react";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [openServices, setOpenServices] = useState(false);
  const [openIndustries, setOpenIndustries] = useState(false);
  const location = useLocation();

  const services = [
    { name: "B2B Email Lists", to: "/services/b2b-email-lists" },
    { name: "B2C Lead Generation", to: "/services/b2c-lead-generation" },
    { name: "Data Appending & Enrichment", to: "/services/data-appending-enrichment" },
    { name: "List Cleaning & Email Validation", to: "/services/list-cleaning-validation" },
    { name: "Web Design & Development", to: "/services/web-design-development" },
    { name: "CRM Data Enhancement", to: "/services/crm-data-enhancement" },
    { name: "Custom Industry Lists", to: "/services/custom-industry-lists" },
    { name: "Global Database Access", to: "/services/global-database-access" },
  ];

  const industries = [
    { name: "Healthcare", to: "/industries/healthcare" },
    { name: "Technology", to: "/industries/technology" },
    { name: "Banking & Finance", to: "/industries/banking-finance" },
    { name: "Manufacturing", to: "/industries/manufacturing" },
    { name: "Travel & Hospitality", to: "/industries/travel-hospitality" },
    { name: "Education & EdTech", to: "/industries/education-edtech" },
    { name: "Retail & eCommerce", to: "/industries/retail-ecommerce" },
    { name: "Security Services", to: "/industries/security-services" },
    { name: "Real Estate", to: "/industries/real-estate" },
    { name: "HR & Recruitment", to: "/industries/hr-recruitment" },
  ];

  return (
    <>
      {/* TOP BAR (DESKTOP ONLY) */}
      <div className="hidden md:block w-full bg-[#0A1E3F] text-white text-sm">
        <div className="max-w-7xl mx-auto px-6 py-2 flex justify-end gap-6">
          <div className="flex items-center gap-2">
            <Phone size={14} className="text-[#00C4CC]" />
            <a href="tel:+13072434039">+1 307-243-4039</a>
          </div>
          <div className="flex items-center gap-2">
            <Mail size={14} className="text-[#00C4CC]" />
            <a href="mailto:info@aquiraa.com">info@aquiraa.com</a>
          </div>
        </div>
      </div>

      {/* HEADER */}
      <header className="bg-white border-b shadow-sm">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-4 flex items-center">

          {/* LOGO + BRAND */}
          <Link to="/" className="flex items-center gap-4">
            {/* LOGO SYMBOL – BIGGER */}
            <img
              src="/logo-symbol.png"
              alt="Aquiraa"
              className="w-16 h-16 md:w-20 md:h-20"
            />

            {/* AQUIRAA TEXT – MATCHING PROVIDED IMAGE */}
            <span
              className="
                text-[28px] md:text-[40px]
                font-medium
                uppercase
                leading-none
                text-[#0A1E3F]
              "
              style={{
                letterSpacing: "0.22em",
                fontFamily: "'Poppins','Inter',sans-serif",
              }}
            >
              AQUIRAA
            </span>
          </Link>

          {/* DESKTOP NAV */}
          <nav className="hidden md:flex ml-auto items-center gap-8 text-[16px] font-medium text-[#0A1E3F]">

            <Link to="/" className="hover:text-[#007BFF]">Home</Link>

            {/* SERVICES DROPDOWN */}
            <div className="relative group">
              <Link to="/services" className="flex items-center gap-1 hover:text-[#007BFF]">
                Services <ChevronDown size={16} />
              </Link>

              <div className="absolute top-full left-0 mt-3 w-64 bg-white shadow-xl rounded-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-50">
                {services.map((s) => (
                  <Link
                    key={s.name}
                    to={s.to}
                    className="block px-5 py-3 text-sm hover:bg-gray-100"
                  >
                    {s.name}
                  </Link>
                ))}
              </div>
            </div>

            {/* INDUSTRIES DROPDOWN */}
            <div className="relative group">
              <Link to="/industries" className="flex items-center gap-1 hover:text-[#007BFF]">
                Industries <ChevronDown size={16} />
              </Link>

              <div className="absolute top-full left-0 mt-3 w-64 bg-white shadow-xl rounded-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-50 max-h-[420px] overflow-y-auto">
                {industries.map((i) => (
                  <Link
                    key={i.name}
                    to={i.to}
                    className="block px-5 py-3 text-sm hover:bg-gray-100"
                  >
                    {i.name}
                  </Link>
                ))}
              </div>
            </div>

            <Link to="/about" className="hover:text-[#007BFF]">About us</Link>
            <Link to="/contact" className="hover:text-[#007BFF]">Contact</Link>
          </nav>

          {/* MOBILE MENU BUTTON */}
          <button
            className="md:hidden ml-auto p-2 border rounded-lg"
            onClick={() => setOpen(true)}
          >
            <Menu size={22} />
          </button>
        </div>
      </header>

      {/* MOBILE DRAWER */}
      {open && (
        <div className="fixed inset-0 z-50">
          <div className="absolute inset-0 bg-black/40" onClick={() => setOpen(false)} />

          <aside className="absolute right-0 top-0 h-full w-72 bg-white p-6 shadow-xl overflow-y-auto">
            <button className="absolute right-4 top-4" onClick={() => setOpen(false)}>
              <X size={20} />
            </button>

            {/* MOBILE BRAND */}
            <div className="flex items-center gap-3 mb-10">
              <img src="/logo-symbol.png" alt="Aquiraa" className="w-14 h-14" />
              <span
                className="text-[22px] uppercase text-[#0A1E3F]"
                style={{ letterSpacing: "0.22em", fontFamily: "'Poppins','Inter',sans-serif" }}
              >
                AQUIRAA
              </span>
            </div>

            <nav className="flex flex-col gap-5 text-lg font-medium text-[#0A1E3F]">

              <Link to="/" onClick={() => setOpen(false)}>Home</Link>

              {/* SERVICES MOBILE */}
              <button
                className="flex justify-between items-center"
                onClick={() => setOpenServices(!openServices)}
              >
                Services <ChevronDown size={18} />
              </button>

              {openServices && services.map((s) => (
                <Link
                  key={s.name}
                  to={s.to}
                  onClick={() => setOpen(false)}
                  className="ml-4 text-sm text-gray-700"
                >
                  {s.name}
                </Link>
              ))}

              {/* INDUSTRIES MOBILE */}
              <button
                className="flex justify-between items-center"
                onClick={() => setOpenIndustries(!openIndustries)}
              >
                Industries <ChevronDown size={18} />
              </button>

              {openIndustries && industries.map((i) => (
                <Link
                  key={i.name}
                  to={i.to}
                  onClick={() => setOpen(false)}
                  className="ml-4 text-sm text-gray-700"
                >
                  {i.name}
                </Link>
              ))}

              <Link to="/about" onClick={() => setOpen(false)}>About us</Link>
              <Link to="/contact" onClick={() => setOpen(false)}>Contact</Link>

              <Link
                to="/contact"
                onClick={() => setOpen(false)}
                className="mt-6 px-5 py-3 bg-[#007BFF] text-white rounded-full text-center"
              >
                Request Sample Data
              </Link>
            </nav>
          </aside>
        </div>
      )}
    </>
  );
}
